import * as Sentry from '@sentry/react';

/**
 * Capture an exception and send it to error monitoring
 * Wrapper around Sentry.captureException for easy provider switching
 */
export const captureException = (
  error: unknown,
  hint?: Parameters<typeof Sentry.captureException>[1],
) => {
  return Sentry.captureException(error, hint);
};

/**
 * Capture a message and send it to error monitoring
 * Wrapper around Sentry.captureMessage for easy provider switching
 */
export const captureMessage = (
  message: string,
  captureContext?: Parameters<typeof Sentry.captureMessage>[1],
) => {
  return Sentry.captureMessage(message, captureContext);
};

/**
 * Add breadcrumb for debugging context
 * Wrapper around Sentry.addBreadcrumb for easy provider switching
 */
export const addBreadcrumb = (
  breadcrumb: Parameters<typeof Sentry.addBreadcrumb>[0],
  hint?: Parameters<typeof Sentry.addBreadcrumb>[1],
) => {
  return Sentry.addBreadcrumb(breadcrumb, hint);
};
